/*
  This component isn't shown until the user has been reading the page for a while. We load enough other stuff during the first few seconds, I don’t want to add this into the mix. So we’ll wait a few seconds before loading.
*/
'use client';

import React from 'react';
import dynamic from 'next/dynamic';

import useTimeout from '@/hooks/use-timeout';

const ToastySubscribe = dynamic(() => import('./ToastySubscribe'), {
  ssr: false,
});

const LOAD_AFTER = 6000;

const LazyToastySubscribe = () => {
  const [hasTimeElapsed, setHasTimeElapsed] = React.useState(false);

  useTimeout(() => {
    setHasTimeElapsed(true);
  }, LOAD_AFTER);

  if (!hasTimeElapsed) {
    return null;
  }

  return <ToastySubscribe />;
};

export default LazyToastySubscribe;
